import styles from "../General/style.module.scss";
import classNames from "classnames";
import { createTimestampDisplay } from "../../../../../uikit/FrameTimestamp/FrameTimestamp";
import ContentBodyLoader from "../../../../../components/MetadataSummary/Content/ContentBody/ContentBodyLoader";

export const SelectedFrame = ({
  img,
  imageUniquenessScore,
  isLoading,
}: any) => {
  return (
    <div className={styles.generalContainer}>
      {isLoading ? (
        <ContentBodyLoader center size={48} />
      ) : (
        img && (
          <div
            className={classNames(styles.infoContainer, styles.frameDetails)}
          >
            <div className={classNames(styles.infoRow)}>
              <div>Frame ID</div>
              <div>{img.id}</div>
            </div>
            <div className={classNames(styles.infoRow)}>
              <div>Timestamp</div>
              <div>{createTimestampDisplay(img.frame_timestamp)}</div>
            </div>
            <div className={classNames(styles.infoRow)}>
              <div>Uniqueness Score</div>
              <div>{imageUniquenessScore}</div>
            </div>
          </div>
        )
      )}
    </div>
  );
};
